"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _MainMenu = require("./MainMenu.styles");

var _Tabs = _interopRequireDefault(require("../Tabs/Tabs"));

var _elements = require("../../styles/elements");

var Title = (0, _base["default"])("h4", {
  target: "ecfqwnv0",
  label: "Title"
})(function (_ref) {
  var theme = _ref.theme,
      as = _ref.as;
  return _elements.heading.styles[as](theme);
}, ";");

var MainMenu = function MainMenu(_ref2) {
  var tabsData = _ref2.tabsData,
      onTabChange = _ref2.onTabChange,
      activeTabKey = _ref2.activeTabKey,
      defaultActiveTabKey = _ref2.defaultActiveTabKey,
      icon = _ref2.icon,
      title = _ref2.title,
      titleTag = _ref2.titleTag,
      content = _ref2.content,
      className = _ref2.className,
      children = _ref2.children,
      imgStyle = _ref2.imgStyle,
      dividerHidden = _ref2.dividerHidden;
  return (0, _jsxRuntime.jsxs)("section", {
    css: _elements.container.styles.base,
    className: (0, _clsx["default"])('grui', className),
    children: [(0, _jsxRuntime.jsxs)("div", {
      css: _MainMenu.styles.wrapper,
      children: [(0, _jsxRuntime.jsxs)("div", {
        className: "grui mr-auto",
        children: [(0, _jsxRuntime.jsxs)("div", {
          css: _MainMenu.styles.heading,
          children: [icon && (0, _jsxRuntime.jsx)("div", {
            css: [_MainMenu.styles.imgBox, imgStyle, process.env.NODE_ENV === "production" ? "" : ";label:MainMenu;"],
            className: "grui mr-10",
            children: (0, _jsxRuntime.jsx)("img", {
              src: icon,
              alt: "icon"
            })
          }), (0, _jsxRuntime.jsxs)("div", {
            children: [(0, _jsxRuntime.jsx)(Title, {
              className: "grui",
              as: titleTag,
              children: title
            }), (0, _jsxRuntime.jsx)("p", {
              css: [_elements.paragraph.styles.preflight, _elements.text.styles.textNormal, _elements.text.styles.textDark, process.env.NODE_ENV === "production" ? "" : ";label:MainMenu;"],
              children: content
            })]
          })]
        }), tabsData && (0, _jsxRuntime.jsx)("div", {
          css: _MainMenu.styles.tabBox,
          children: (0, _jsxRuntime.jsx)(_Tabs["default"], {
            tabs: tabsData,
            type: "small",
            onChange: onTabChange,
            activeKey: activeTabKey,
            defaultActiveKey: defaultActiveTabKey
          })
        })]
      }), children]
    }), !dividerHidden && (0, _jsxRuntime.jsx)("div", {
      css: _elements.divider.styles.base,
      role: "separator"
    })]
  });
};

MainMenu.propTypes = {
  /**
   * Data for tabs
   */
  tabsData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    key: _propTypes.string.isRequired,
    tabName: _propTypes.string.isRequired
  })),
  onTabChange: _propTypes.func,

  /**
   * Current TabPane's key: control active key without clicking titles
   */
  activeTabKey: _propTypes.string,

  /**
   * Initial active TabPane's key, if activeKey is not set
   */
  defaultActiveTabKey: _propTypes.string,
  icon: _propTypes.string,
  title: _propTypes.string,
  titleTag: (0, _propTypes.oneOf)(['h1', 'h2', 'h3', 'h4']),
  content: _propTypes.string,
  className: _propTypes.string,
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  imgStyle: (0, _propTypes.shape)({
    styles: _propTypes.string
  }),

  /**
   * Whether the divider line is hidden
   */
  dividerHidden: _propTypes.bool
};
MainMenu.defaultProps = {
  tabsData: undefined,
  onTabChange: function onTabChange() {},
  activeTabKey: undefined,
  defaultActiveTabKey: undefined,
  icon: undefined,
  title: undefined,
  titleTag: 'h4',
  content: undefined,
  className: undefined,
  children: undefined,
  imgStyle: undefined,
  dividerHidden: false
};
var _default = MainMenu;
exports["default"] = _default;
//# sourceMappingURL=MainMenu.js.map